exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".answerAnalysisDisplay{margin-top:10px;margin-bottom:20px}.answerAnalysisDisplay .collapseOption{float:right;font-size:.8em;cursor:pointer}.answerAnalysisDisplay .feedbackArea{padding:20px;margin-bottom:50px}.answerAnalysisDisplay .categoryRow{margin-bottom:10px}.answerAnalysisDisplay .feedbackTable{width:100%}.answerAnalysisDisplay .feedbackTable .validCountCell{width:20%}.answerAnalysisDisplay .feedbackTable .descriptionCell{font-size:13px;width:80%}.answerAnalysisDisplay .feedbackTable .valid{color:#42af14}.answerAnalysisDisplay .feedbackTable .average{color:#ede309}.answerAnalysisDisplay .feedbackTable .error{color:#da3956}.answerAnalysisDisplay .feedbackTable .icon{height:15px;width:1.8rem;float:right}.answerAnalysisDisplay .feedbackTable .appearIn{width:100%;height:auto}.answerAnalysisDisplay .hiddenElement{display:none}.answerAnalysisDisplay .reactionFeedback{float:right;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/answers/answer_analysis_display.scss
// module id = 1469
// module chunks = 0